import { AgreedDocs } from '@porterin/booking-flow/src/order-review/domain/entities/AgreedDocs';
import { CreateTrip } from '@porterin/booking-flow/src/order-review/domain/entities/CreateTrip';
import {
  CustomerDetails,
  GoodsType,
} from '@porterin/booking-flow/src/order-review/domain/entities/CustomerDetails';
import { GeoRegionLocation } from '@porterin/booking-flow/src/order-review/domain/entities/GeoRegionLocation';
import { GeoRegionRestrictions } from '@porterin/booking-flow/src/order-review/domain/entities/GeoRegionRestrictions';
import {
  ClientData,
  getDefault,
} from '@porterin/booking-flow/src/order-review/domain/entities/OrderReviewClientData';
import { Quotations } from '@porterin/booking-flow/src/order-review/domain/entities/Quotations';
import { VehicleResult } from '@porterin/booking-flow/src/order-review/domain/entities/VehicleResult';
import { VehiclesAvailable } from '@porterin/booking-flow/src/order-review/domain/entities/VehiclesAvailable';
import { Loadable } from '@porterin/booking-flow/src/order-review/view/types/Loadable';
import { PaymentMethod } from '../../domain/entities/PaymentMethod';
import { PaymentMethodOption } from '@porterin/component-library/src/feature-components/payment-method-modal/PaymentMethodModal';

export type ApiResults = {
  geoRegionId?: number;
  customerDetails?: CustomerDetails;
  locationBounds?: GeoRegionLocation;
  restrictionBounds?: GeoRegionRestrictions;
  vehicleDetails?: VehiclesAvailable;
  restrictedVehicles?: number[];
  quotations?: Quotations;
  customerAgreedDocs?: AgreedDocs;
  createTrip?: CreateTrip;
};

export type OrderReviewSelectedState = {
  selectedVehicle: number;
  selectedVehicleFare: string;
  selectedGoodsType?: GoodsType;
  selectedPaymentMethod?: PaymentMethod;
  orderRemarks?: string;
};

export type ClientDataState = {
  data: ClientData;
  isValidStatus: Loadable<boolean, any>;
};

export type PaymentOptions = {
  [key in PaymentMethod]: PaymentMethodOption;
};

export type OrderReviewUserInputState =
  | 'vehicle_selection' // Default initial state / idle state
  | 'goods_selection'
  | 'payment_selection'
  | 'remarks'
  | 'confirmation';

export interface State {
  clientData: ClientDataState;
  apiResults?: ApiResults;
  paymentOptions: PaymentOptions;
  vehicleResults?: VehicleResult[];
  showAgreedDocs: boolean;
  isRetry: boolean;
  isCreateTripRetry: boolean;
  isRefetchQuotation: number;
  isCreateTripDisabled: boolean;
  isPaymentMethodDisabled: boolean;
  selectedState: OrderReviewSelectedState;
  userInputState: OrderReviewUserInputState;
}

export type Action<K extends string, P> = { type: K; payload: P };

export type Actions =
  | Action<'SetClientData', Partial<ClientDataState>>
  | Action<'SetApiResults', Partial<ApiResults>>
  | Action<'SetVehicleResults', VehicleResult[] | undefined>
  | Action<'SetShowAgreedDocs', boolean>
  | Action<'SetIsRetry', boolean>
  | Action<'SetIsCreateTripRetry', boolean>
  | Action<'SetIsRefetchQuotation', void>
  | Action<'SetIsCreateTripDisabled', boolean>
  | Action<'SetIsPaymentMethodDisabled', boolean>
  | Action<'SetSelectedState', Partial<OrderReviewSelectedState>>
  | Action<'SetUserInputState', OrderReviewUserInputState>
  | Action<'UpdatePaymentOptions', Partial<PaymentOptions>>;

export const getInitialState = (): State => {
  return {
    clientData: {
      data: getDefault(),
      isValidStatus: { state: 'Init' },
    },
    apiResults: undefined,
    vehicleResults: undefined,
    showAgreedDocs: false,
    isRetry: false,
    isCreateTripRetry: false,
    isCreateTripDisabled: true,
    isPaymentMethodDisabled: false,
    isRefetchQuotation: 0,
    selectedState: {
      selectedVehicle: 0,
      selectedVehicleFare: '0',
      selectedGoodsType: undefined,
      selectedPaymentMethod: undefined,
    },
    paymentOptions: {} as PaymentOptions,
    userInputState: 'vehicle_selection',
  };
};
